import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyDGMxpsuvCwKG76ulZkrVsiQPYQ9L9R5Xc",
    authDomain: "trio-7b4c6.firebaseapp.com",
    projectId: "trio-7b4c6",
    storageBucket: "trio-7b4c6.firebasestorage.app",
    messagingSenderId: "205622187899",
    appId: "1:205622187899:web:f549b9420767287cab8fde",
    measurementId: "G-YG0VB5S4FN"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();